import { Filters } from '../filters/Filters';
import { PopularDestinations } from '../popularDestinations/PopularDestinations';
import { SaveSearch } from '../saveSearch/SaveSearch';
import { SmallFhhMap } from '../smallFhhMap/SmallFhhMap';
import { AutocompleteData, Filters as FiltersType } from '@/domain';

type ResultFilterProps = {
    autocompleteData: AutocompleteData;
    fetchAutocomplete: (query, sessionToken) => void;
    updateAutocomplete: (selected, trackingInfo) => void;
    filters: FiltersType;
    filterData: Record<string, unknown>;
    onFilterChanged: (filters: FiltersType) => void;
    isLoggedIn: boolean;
    isMobile?: boolean;
};

export const ResultFilter = (props: ResultFilterProps) => (
    <div>
        <div className="hidden md:block">
            <SaveSearch filters={props.filters} autocompleteData={props.autocompleteData} isLoggedIn={props.isLoggedIn} />
            <div className="border-t p-16">
                <SmallFhhMap filters={props.filters} />
            </div>
        </div>
        <Filters onFilterChanged={props.onFilterChanged} filterData={props.filterData} filters={props.filters} />
        <PopularDestinations onFilterChanged={props.onFilterChanged} updateAutocomplete={props.updateAutocomplete} />
    </div>
);
